import React, { ChangeEvent, FunctionComponent } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { SingleSegmentedControlStepProps } from 'scenes/common/types';
import { FormGroup, SegmentedControl } from 'components/chroma';
import { SubmitButton } from 'components';
import ButtonLinkRedirect from 'components/ButtonLinkRedirect';

const STATE_KEY = 'kickOutChoice';
export const QUESTION = 'Please confirm how you use this property';

const KickOutStep: FunctionComponent<
  Pick<
    SingleSegmentedControlStepProps<string, string>,
    'defaultStateValue' | 'onNext' | 'options' | 'helpText'
  > & { onUpdateKickOutChoice: (choice: string) => void; redirectUrl?: string }
> = ({
  defaultStateValue,
  onNext,
  options,
  helpText,
  redirectUrl,
  onUpdateKickOutChoice,
}) => {
  const { formState: hooksForm, handleSubmit, control, errors } = useForm({
    mode: 'onChange',
  });

  return (
    <form onSubmit={handleSubmit(onNext)}>
      <Controller
        control={control}
        name={STATE_KEY}
        defaultValue={defaultStateValue}
        rules={{
          required: true,
        }}
        render={({ onChange, value }) => (
          <FormGroup
            id={STATE_KEY}
            legend={QUESTION}
            helpText={helpText || ''}
            error={errors[STATE_KEY]?.message || ''}
          >
            <SegmentedControl
              stack
              id={STATE_KEY}
              name={STATE_KEY}
              values={options}
              value={value}
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                onChange(event);
                onUpdateKickOutChoice(event.target.value);
              }}
            />
          </FormGroup>
        )}
      />
      {redirectUrl ? (
        <ButtonLinkRedirect url={redirectUrl} label="Next" ariaLabel="Next" />
      ) : (
        <SubmitButton enabled={hooksForm.isValid}>Next</SubmitButton>
      )}
    </form>
  );
};

export default KickOutStep;
